import {registerPlugin} from "@capacitor/core";

const UserConsent = registerPlugin("UserConsent");

export default UserConsent;